export default function (string) {
  return {
    kebabToTitle: () => {
      if (!string) {
        // Handle empty strings or null values
        return ''
      }

      const words = string.split('-') // Split the string into words
      const capitalizedWords = words.map((word) => {
        // Capitalize the first letter of each word
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      })

      return capitalizedWords.join(' ') // Join the capitalized words back into a string
    }
  }
}
